// extracted by mini-css-extract-plugin
export var quantityInput = "_on-0";